export default function Marquee({ items }) {
    return (
        <div
            data-testid="marquee-band"
            className="marquee-hover relative overflow-hidden border-y border-white/10 bg-panel/50 py-5"
        >
            <div className="flex w-max animate-marquee items-center">
                {[0, 1].map((half) => (
                    <div key={half} aria-hidden={half === 1} className="flex items-center">
                        {items.map((it, i) => (
                            <span key={i} className="flex shrink-0 items-center">
                                <span className="whitespace-nowrap px-8 font-mono text-xs uppercase tracking-[0.22em] text-slate-300 md:text-sm">
                                    {it}
                                </span>
                                <span className="font-mono text-xs text-amber-400">//</span>
                            </span>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
}
